document.addEventListener('DOMContentLoaded', function () {
  // Plantstrong custom JS

  // ── Klaviyo Back-in-Stock modal ──
  // Shared controller. Any OOS trigger calls window.PSBackInStock.open(variantId);
  // we create a client-side back-in-stock subscription via the Klaviyo public key.
  // Defined FIRST so the global exists even if a later block in this callback throws.
  (function () {
    var modal = document.getElementById('ps-bis-modal');
    if (!modal) return;

    var publicKey  = modal.dataset.publicKey;
    var dialog     = modal.querySelector('.ps-bis-dialog');
    var form       = modal.querySelector('.ps-bis-form');
    var emailInput = modal.querySelector('.ps-bis-email');
    var submitBtn  = modal.querySelector('.ps-bis-submit');
    var messageEl  = modal.querySelector('.ps-bis-message');
    var currentVariantId = null;
    var lastFocused = null;
    var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

    function setMessage(text, type) {
      messageEl.textContent = text || '';
      messageEl.className = 'ps-bis-message' + (type ? ' ps-bis-message--' + type : '');
    }

    function open(variantId) {
      if (!variantId) return;
      currentVariantId = String(variantId);
      lastFocused = document.activeElement;
      form.reset();
      setMessage('', null);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Notify me';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ps-bis-lock');
      setTimeout(function () { emailInput.focus(); }, 50);
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ps-bis-lock');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-bis-close')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      // Focus trap: keep Tab focus inside the dialog (honors aria-modal).
      if (e.key === 'Tab') {
        var focusable = Array.prototype.filter.call(
          dialog.querySelectorAll('button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'),
          function (el) { return !el.disabled && el.offsetParent !== null; }
        );
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!EMAIL_RE.test(email)) {
        setMessage('Please enter a valid email address.', 'error');
        emailInput.focus();
        return;
      }
      if (!currentVariantId) {
        setMessage('Something went wrong. Please try again.', 'error');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      setMessage('', null);

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariantId }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.ok) { // 202 Accepted on success
            setMessage("You're on the list! We'll email you when it's back in stock.", 'success');
            submitBtn.textContent = 'Done';
            submitBtn.disabled = true;
          } else {
            throw new Error('HTTP ' + res.status);
          }
        })
        .catch(function () {
          setMessage('Sorry, something went wrong. Please try again.', 'error');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Notify me';
        });
    });

    window.PSBackInStock = { open: open, close: close };
  })();

  // ── Sticky ATC ──
  var stickyBar   = document.getElementById('ps-sticky-atc');
  var productMain = document.querySelector('.ps-product-main');
  if (stickyBar && productMain) {
    var mainForm       = productMain.querySelector('.product-form');
    var variantIdInput = mainForm && mainForm.querySelector('.variant-id-input');
    var variantsEl     = mainForm && mainForm.querySelector('.product-variants-json');

    if (mainForm && variantIdInput && variantsEl) {
      var variants     = JSON.parse(variantsEl.textContent);
      // The price exists twice: in the desktop right-hand column and in the
      // mobile summary line under the title. Only one is ever visible, but both
      // are kept in sync so a rotation or resize never reveals a stale price.
      var stickyPrices   = Array.from(stickyBar.querySelectorAll('.sticky-price'));
      var stickyCompares = Array.from(stickyBar.querySelectorAll('.sticky-compare-at-price'));
      var stickyBtn    = stickyBar.querySelector('.sticky-atc-btn');
      var stickySelects = Array.from(stickyBar.querySelectorAll('.sticky-option-select'));
      // Variant pills only: the purchase-type buttons share the pill styling
      // but carry no option index and are driven separately below.
      var stickyPills   = Array.from(stickyBar.querySelectorAll('.sticky-pill[data-option-index]'));
      var stickyExpand  = stickyBar.querySelector('.sticky-expand');

      // Plan resolution and the price it implies now live in assets/ps-price.js,
      // because the Add to Cart button carries the price too — a sticky bar
      // computing its own would put two numbers for the same choice on one
      // screen the moment either copy drifted.
      function currentPlanId() {
        return window.PSPrice ? window.PSPrice.planId(productMain) : '';
      }

      function formatMoney(cents) {
        return window.PSPrice
          ? window.PSPrice.format(cents)
          : '$' + (cents / 100).toFixed(2);
      }

      function currentVariant() {
        var id = parseInt(variantIdInput.value, 10);
        return variants.find(function (v) { return v.id === id; }) || null;
      }

      // Locate a buy box pill without interpolating the option value into a
      // selector: a value containing a quote, bracket or backslash would make
      // querySelector throw and take the whole sticky bar down with it. The
      // option index is our own Liquid loop counter, so it is safe to inline.
      function mainPillFor(optionIndex, value) {
        var group = mainForm.querySelector('.variant-option[data-option-index="' + optionIndex + '"]');
        if (!group) return null;
        return Array.prototype.find.call(group.querySelectorAll('.pill'), function (p) {
          return p.dataset.value === value;
        }) || null;
      }

      function syncStickyUI() {
        var variant = currentVariant();
        // Hides the quantity stepper whenever the button is not a live Add to
        // Cart (Unavailable or Back-in-Stock) - there is no quantity to pick.
        stickyBar.classList.toggle('is-unavailable', !variant || !variant.available);

        if (!variant) {
          // No matching variant (e.g. main form cleared the id): don't let the
          // sticky bar add to cart or open BIS against a stale variant id.
          if (stickyBtn) {
            stickyBtn.disabled    = true;
            stickyBtn.textContent = 'Unavailable';
            stickyBtn.classList.remove('sticky-atc-btn--bis');
          }
          return;
        }

        // Mirror the main buy box's selected purchase type. When a subscription
        // plan is chosen, show its discounted per-delivery price (with the
        // one-time price as the strikethrough compare-at) instead of the raw
        // one-time price — otherwise the sticky bar advertises a price that
        // differs from what actually gets added to the cart.
        var shown = window.PSPrice
          ? window.PSPrice.resolve(variant, currentPlanId())
          // Without ps-price.js there is no plan-aware price, but a sale still
          // has its compare-at; dropping it hid the strikethrough on sale items.
          : {
              price: variant.price,
              compareAt: variant.compare_at_price > variant.price ? variant.compare_at_price : null
            };

        stickyPrices.forEach(function (el) {
          el.textContent = formatMoney(shown.price);
        });
        stickyCompares.forEach(function (el) {
          if (shown.compareAt) {
            el.textContent = formatMoney(shown.compareAt);
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });

        if (stickyBtn) {
          // Out-of-stock → Back-in-Stock trigger (clickable), mirroring the main form.
          stickyBtn.disabled    = false;
          stickyBtn.textContent = variant.available ? 'Add to Cart' : 'Notify me when back in stock';
          stickyBtn.classList.toggle('sticky-atc-btn--bis', !variant.available);
        }

        stickySelects.forEach(function (sel) {
          var idx = parseInt(sel.dataset.optionIndex, 10);
          var val = variant.options[idx];
          if (val && sel.value !== val) sel.value = val;
        });

        // Mobile picker: highlight the selected pill, spell the value out in the
        // group label ("Size: M") and in the summary line under the title.
        stickyPills.forEach(function (pill) {
          var idx = parseInt(pill.dataset.optionIndex, 10);
          pill.classList.toggle('active', pill.dataset.value === variant.options[idx]);
        });

        stickyBar.querySelectorAll('.sticky-option-group[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.dataset.optionIndex, 10);
          var valueEl = group.querySelector('.sticky-selected-value');
          if (valueEl) valueEl.textContent = variant.options[idx];
        });

        stickyBar.querySelectorAll('.sticky-summary-option').forEach(function (el) {
          var idx = parseInt(el.dataset.optionIndex, 10);
          el.textContent = variant.options[idx];
        });

        syncPurchaseUI();
      }

      // ── Purchase type in the mobile sheet ──
      // The bar owns no StayAI widget. Its One-time / Subscribe buttons and the
      // frequency select drive the buy box's own StayAI controls, and are
      // redrawn from them here, so what the sheet shows is exactly what the add
      // (which posts the buy box form) will carry. Queried on use rather than
      // cached: StayAI re-renders its widget asynchronously.
      var purchaseGroup = stickyBar.querySelector('.sticky-purchase');
      var ptBtns        = purchaseGroup ? Array.from(purchaseGroup.querySelectorAll('.sticky-pt-btn')) : [];
      var freqSelect    = purchaseGroup && purchaseGroup.querySelector('.sticky-freq-select');

      function mainPurchaseRadio(type) {
        return mainForm.querySelector(
          'input[name="purchaseType"][value="' +
          (type === 'subscribe' ? 'purchaseTypeSubscription' : 'purchaseTypeOneTime') + '"]'
        );
      }

      function mainPlanSelect() {
        return mainForm.querySelector('select[name="stayai_selling_plan"]');
      }

      function syncPurchaseUI() {
        if (!purchaseGroup) return;

        // No StayAI radios (the app failed to load, or offers no plan for this
        // product): hide the group rather than show buttons that do nothing.
        var subRadio = mainPurchaseRadio('subscribe');
        var oneRadio = mainPurchaseRadio('onetime');
        purchaseGroup.hidden = !(subRadio && oneRadio);
        if (purchaseGroup.hidden) return;

        var isSub = subRadio.checked;
        ptBtns.forEach(function (btn) {
          btn.classList.toggle('active', (btn.dataset.pt === 'subscribe') === isSub);
        });

        // " 20%" read from StayAI's own label, so the sheet never promises a
        // discount the plan does not give.
        var savingsEl = purchaseGroup.querySelector('.sticky-pt-savings');
        var mainSavings = mainForm.querySelector('.subscription-savings');
        if (savingsEl) savingsEl.textContent = mainSavings ? ' ' + mainSavings.textContent.trim() : '';

        var planSel = mainPlanSelect();
        if (freqSelect) {
          freqSelect.hidden = !isSub || !planSel || planSel.options.length < 2;
          if (planSel) {
            // Rebuild only when StayAI's list changed (a variant switch can).
            var signature = Array.from(planSel.options).map(function (o) { return o.value; }).join(',');
            if (freqSelect.dataset.signature !== signature) {
              freqSelect.replaceChildren.apply(freqSelect, Array.from(planSel.options).map(function (o) {
                return new Option(o.text, o.value);
              }));
              freqSelect.dataset.signature = signature;
            }
            if (freqSelect.value !== planSel.value) freqSelect.value = planSel.value;
          }
        }
      }

      ptBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var radio = mainPurchaseRadio(btn.dataset.pt);
          // StayAI listens for the radio's own click/change; a plain
          // `checked = true` would leave its price and selling_plan behind.
          if (radio && !radio.checked) radio.click();
          syncStickyUI();
        });
      });

      if (freqSelect) {
        freqSelect.addEventListener('change', function () {
          var planSel = mainPlanSelect();
          if (!planSel) return;
          planSel.value = freqSelect.value;
          planSel.dispatchEvent(new Event('change', { bubbles: true }));
          syncStickyUI();
        });
      }

      // The design sizes every pill column to the longest value in its group —
      // three columns for "S / M / L", two for "Garnet Red", one for
      // "1 Box of 6 Microwave Bags". CSS cannot measure text, so lay the pills
      // out at their natural width once, read the widest, and pick how many
      // equal columns fit. Only runs while the panel is open: inside a
      // display:none subtree every measurement would come back as 0.
      function layoutStickyPills() {
        if (!stickyBar.classList.contains('is-expanded')) return;

        // The purchase-type pair is always two equal columns (CSS), not measured.
        stickyBar.querySelectorAll('.sticky-option-group[data-option-index] .sticky-option-pills').forEach(function (grid) {
          var available = grid.getBoundingClientRect().width;
          if (!available) return;

          grid.classList.add('is-measuring');
          var widest = 0;
          grid.querySelectorAll('.sticky-pill').forEach(function (pill) {
            widest = Math.max(widest, pill.getBoundingClientRect().width);
          });
          grid.classList.remove('is-measuring');
          if (!widest) return;

          var gap = 8;
          var fits = Math.floor((available + gap) / (widest + gap));
          grid.style.gridTemplateColumns = 'repeat(' + Math.min(3, Math.max(1, fits)) + ', 1fr)';
        });
      }

      // ── Choose before adding (audit M3, mobile only) ──
      // With data-choose-first, the first tap on the sticky button opens the
      // sheet so the shopper sees the pack and One-time / Subscribe choice
      // before anything goes into the cart. Anyone who has already chosen —
      // opened the sheet, or touched a pack or the purchase type in the buy
      // box — is not made to tap twice.
      var chooseFirst = stickyBar.hasAttribute('data-choose-first');
      var hasChosen   = false;

      function markChosen() {
        hasChosen = true;
      }

      // Real taps in the buy box only: the sheet's own proxies click the same
      // controls programmatically, and those are counted where they happen.
      mainForm.addEventListener('click', function (e) {
        if (!e.isTrusted) return;
        if (e.target.closest && e.target.closest('.pill, .stayai-purchase-label')) markChosen();
      });
      mainForm.addEventListener('change', function (e) {
        if (e.isTrusted && e.target && e.target.name === 'stayai_selling_plan') markChosen();
      });
      stickyBar.querySelectorAll('.sticky-pill, .sticky-freq-select').forEach(function (el) {
        el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'click', markChosen);
      });

      function setStickyExpanded(expanded) {
        stickyBar.classList.toggle('is-expanded', expanded);
        if (stickyExpand) stickyExpand.setAttribute('aria-expanded', String(expanded));
        syncWidgetClearance();
        if (expanded) {
          markChosen();
          // StayAI may have finished rendering since the last sync; the
          // one-time default leaves no plan change for the poll to catch.
          syncPurchaseUI();
          layoutStickyPills();
        }
      }

      // Whether the button should open the sheet instead of adding. The
      // chevron is only laid out on the mobile sheet, so its visibility is the
      // breakpoint test — desktop always adds straight away.
      function shouldOpenSheetFirst() {
        return chooseFirst &&
          !hasChosen &&
          !!stickyExpand && !!stickyExpand.offsetParent &&
          !stickyBar.classList.contains('is-expanded');
      }

      if (stickyExpand) {
        // The whole product row toggles the panel, not just the chevron: on a
        // phone the strip is the obvious thing to tap and the 44px glyph alone
        // is easy to miss. The chevron sits inside the row, so its own click —
        // including the one a keyboard Enter/Space synthesises — bubbles up
        // here and needs no separate handler.
        var stickyLeft = stickyBar.querySelector('.sticky-left');

        (stickyLeft || stickyExpand).addEventListener('click', function () {
          // Desktop keeps the chevron hidden and the pills with it, so the row
          // must stay inert there.
          if (!stickyExpand.offsetParent) return;

          setStickyExpanded(!stickyBar.classList.contains('is-expanded'));
        });

        // A rotation changes how many columns fit, and the pills only carry a
        // width while the panel is open — so re-measure rather than cache.
        window.addEventListener('resize', layoutStickyPills);
      }

      // Sticky pill → click the matching pill in the main form, which owns the
      // variant resolution. Sold-out values stay selectable, exactly like the
      // buy box: picking one switches the button to the back-in-stock trigger.
      stickyPills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var mainPill = mainPillFor(pill.dataset.optionIndex, pill.dataset.value);
          if (mainPill) mainPill.click();
        });
      });

      // Plan changes are event-driven: StayAI's purchaseType radios and the
      // frequency <select> emit standard `change` events, so sync the sticky
      // price from them immediately. Delegated on the product section so it keeps
      // working across StayAI's async re-renders of the widget.
      productMain.addEventListener('change', function (e) {
        var name = e.target && e.target.name;
        if (name === 'purchaseType' || name === 'stayai_selling_plan') syncStickyUI();
      });

      // Fallback poll for the variant id: the main-form pills assign
      // variantIdInput.value directly with no event to listen for. Also re-checks
      // the plan in case StayAI repopulates it programmatically (e.g. Safari /
      // bfcache restore) without firing change.
      var lastVariantId = variantIdInput.value;
      var lastPlanId = currentPlanId();
      setInterval(function () {
        var planNow = currentPlanId();
        if (variantIdInput.value !== lastVariantId || planNow !== lastPlanId) {
          lastVariantId = variantIdInput.value;
          lastPlanId = planNow;
          syncStickyUI();
        }
      }, 150);

      // Sticky select → click matching pill in main form
      stickySelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var pill = mainPillFor(sel.dataset.optionIndex, sel.value);
          if (pill) pill.click();
        });
      });

      // Sticky ATC submit
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var variantId = variantIdInput.value;
          if (!variantId) return;

          // BIS mode: open the Back-in-Stock modal instead of adding to cart.
          if (stickyBtn.classList.contains('sticky-atc-btn--bis')) {
            if (window.PSBackInStock) window.PSBackInStock.open(variantId);
            return;
          }

          if (shouldOpenSheetFirst()) {
            setStickyExpanded(true);
            return;
          }

          if (!window.PSAtc) {
            // The feedback asset failed to load. Back-in-stock above still works.
            console.error('[ps-atc] ps-atc-feedback.js did not load; add to cart is unavailable.');
            return;
          }

          stickyBtn.disabled    = true;
          stickyBtn.textContent = 'Adding...';

          // Per the client, the sticky bar behaves the old way: it opens the
          // Rebuy drawer instead of flying to the icon. openDrawer:true tells
          // PSAtc not to suppress the drawer, so Rebuy auto-opens on the add.
          // No flight and no message here — the drawer is the feedback.
          window.PSAtc.addToCart(mainForm, { openDrawer: true })
            .then(function () {
              // Back to 1, same as the buy box button does.
              window.PSAtc.resetQuantity(mainForm);
              // The choice is made; fold the sheet away under the cart drawer.
              setStickyExpanded(false);
            })
            .catch(function (error) {
              console.error('[ps-atc] sticky add to cart failed:', error && error.message);
            })
            .then(function () {
              syncStickyUI();
            });
        });
      }

      // Show the bar whenever the buy box's own Add to Cart button is off
      // screen. Watching the whole .ps-product-main section instead meant the
      // bar only appeared once the gallery, the description and everything
      // below the button had scrolled past too, leaving a long stretch of the
      // page with no way to add the product.
      // Only once it has scrolled ABOVE the viewport, though: on a phone the
      // button starts well below the fold, and a bar that is already there on
      // load would cover the gallery before the customer has scrolled at all.
      // ── Third-party corner widgets ──
      // Klaviyo's hub launcher and Pandectes' consent button are both fixed to
      // the bottom-right corner, at a z-index we cannot outrank (2147483646 and
      // 1000 against our 500), so they land on the right edge of ADD TO CART.
      // Publish how far they have to move and let CSS do the moving.
      //
      // Pandectes' button is placed by the corner widget dock (see "Corner widget
      // dock" further down and in custom.css), which reads --ps-widget-lift.
      // Only hiding it while the sheet is open still needs a rule
      // inside that open shadow root; custom properties cross the boundary,
      // which is why the state travels as values rather than as a class.
      var PANDECTES_STYLE = [
        '.widget.bottom.right {',
        '  opacity: var(--ps-widget-fade, 1);',
        '  pointer-events: var(--ps-widget-events, auto);',
        '  transition: opacity 0.2s ease;',
        '}'
      ].join('\n');

      function styleConsentWidget() {
        var host = document.querySelector('pandectes-cmp');
        // closed shadow root, or the app is gone: nothing to do, nothing breaks
        if (!host || !host.shadowRoot) return;
        if (host.shadowRoot.getElementById('ps-widget-clearance')) return;

        var style = document.createElement('style');
        style.id = 'ps-widget-clearance';
        style.textContent = PANDECTES_STYLE;
        host.shadowRoot.appendChild(style);
      }

      function syncWidgetClearance() {
        var docEl    = document.documentElement;
        var visible  = stickyBar.classList.contains('is-visible');
        var expanded = stickyBar.classList.contains('is-expanded');
        // Expanded, the sheet is half the screen tall — lifting the widgets
        // that far would strand them mid-page, so there they step aside.
        var lift = visible && !expanded
          ? Math.round(stickyBar.getBoundingClientRect().height) + 'px'
          : '0px';

        docEl.classList.toggle('ps-sticky-visible', visible);
        docEl.classList.toggle('ps-sticky-expanded', visible && expanded);
        docEl.style.setProperty('--ps-widget-lift', lift);
        docEl.style.setProperty('--ps-widget-fade', visible && expanded ? '0' : '1');
        docEl.style.setProperty('--ps-widget-events', visible && expanded ? 'none' : 'auto');

        // The consent app mounts late and only for visitors it has to ask, so
        // the root is looked for on every sync rather than once on load.
        styleConsentWidget();
      }

      // The bar grows with the sheet, a wrapped label or a rotation; re-read it
      // whenever it resizes rather than guessing a height.
      if (window.ResizeObserver) {
        new ResizeObserver(syncWidgetClearance).observe(stickyBar);
      } else {
        window.addEventListener('resize', syncWidgetClearance);
      }

      var atcAnchor = mainForm.querySelector('.atc-wrapper') || productMain;
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // rootBounds is null when the observer cannot resolve the root; the
        // root here is the viewport, whose top is 0 anyway.
        var rootTop = entry.rootBounds ? entry.rootBounds.top : 0;
        var scrolledPast = entry.boundingClientRect.bottom <= rootTop;
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
        syncWidgetClearance();
      }, { threshold: 0 });
      io.observe(atcAnchor);

      syncStickyUI();
    }
  }

  // ── StayAI: picking a frequency opts into the subscription ──
  // The frequency <select> is visible while One-Time is selected (per the design),
  // so a customer can pick a cadence and still be charged a one-time full price —
  // buildPayload() in ps-atc-feedback.js only sends selling_plan when the radio
  // says subscription. Treat picking a cadence as the intent to subscribe.
  //
  // Delegated from document so it works regardless of when stayai-pdp.js upgrades
  // <purchase-options>, and so the widget's own change handler (bound to the
  // select) has already run by the time this fires.
  (function () {
    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select.matches || !select.matches('select[name="stayai_selling_plan"]')) return;

      // The empty option is StayAI's "Select frequency" placeholder, not a cadence.
      if (!select.value) return;

      var widget = select.closest('purchase-options');
      if (!widget) return;

      var subscriptionRadio = widget.querySelector('input[value="purchaseTypeSubscription"]');
      if (!subscriptionRadio || subscriptionRadio.checked) return;

      // .click() rather than .checked = true: only the former fires the radio's
      // change event, and that event is what drives the widget's show/hide, its
      // price refresh and the hidden selling_plan input. Works even in the
      // layouts that render the radio display:none, since a synthetic click does
      // not require the element to be visible.
      subscriptionRadio.click();
    });
  })();

  // ── Breadcrumbs: fade the trailing edge while there is more to scroll ──
  // On mobile the trail is one swipeable line (see custom.css). The fade tells
  // the customer the row continues; it must disappear once they reach the end,
  // otherwise the last crumb looks washed out for no reason. The mask itself
  // lives in CSS behind this class, so desktop — where the row wraps and never
  // scrolls — is untouched even while the class is set.
  (function () {
    var trail = document.querySelector('.ps-breadcrumb');
    if (!trail) return;

    function update() {
      // 1px of slack: fractional layout widths never land on an exact equality.
      var atEnd = trail.scrollLeft + trail.clientWidth >= trail.scrollWidth - 1;
      trail.classList.toggle('is-fade-end', !atEnd);
    }

    update();
    trail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Futura arrives via @font-face, and the swap re-measures every crumb.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  })();

  // ── Cookie consent (Pandectes) ──
  // Pandectes' floating "change your consent" button is hidden; the consent
  // notice instead
  // - opens on its own once per browser session for visitors who have not
  //   chosen yet (a first visit already gets it from Pandectes), and
  // - opens from any link to #cookie-preferences or [data-ps-cookie-preferences],
  //   e.g. "Change my cookie preferences" on the Your Privacy Choices page.
  // Pandectes has no public "open" call; both paths press its hidden button.
  // Before a choice it opens the notice; after one it opens the Preferences
  // dialog, which is what the "change my preferences" links want.
  //
  // The notice's own rules (dock placement, compact card) live in
  // snippets/ps-consent-style.liquid.
  (function () {
    var SESSION_KEY = 'ps-consent-notice-shown';
    // Shared with snippets/ps-consent-style.liquid, which applies them the
    // moment Pandectes attaches its shadow root; this is the fallback.
    var CONSENT_RULES = window.PSConsentRules;

    function consentRoot() {
      var host = document.querySelector('pandectes-cmp');
      // closed shadow root, or the app is gone: nothing to do, nothing breaks
      return host && host.shadowRoot;
    }

    // An adopted sheet survives Pandectes re-rendering its root, which a
    // <style> element would not (same approach as snippets/ps-sticky-atc).
    function styleConsent(root) {
      if (root.__psConsentStyled || !CONSENT_RULES) return;
      root.__psConsentStyled = true;
      if ('adoptedStyleSheets' in root && window.CSSStyleSheet && 'replaceSync' in CSSStyleSheet.prototype) {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(CONSENT_RULES);
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
      } else {
        var style = document.createElement('style');
        style.textContent = CONSENT_RULES;
        root.appendChild(style);
      }
    }

    // The notice is a native <dialog>; a closed one may stay in the root, so
    // only a dialog that is actually open or on screen counts.
    function noticeOpen(root) {
      var dialog = root.querySelector('.dialog');
      return !!dialog && (dialog.open || dialog.getClientRects().length > 0);
    }

    // true once the notice is open (or already was); false while Pandectes has
    // rendered neither its button nor its notice yet.
    function openConsentNotice() {
      var root = consentRoot();
      if (!root) return false;
      if (noticeOpen(root)) return true;
      var button = root.querySelector('button.widget');
      if (!button) return false;
      button.click();
      return true;
    }

    // Pandectes stores the visitor's choice in this cookie. Once it is there
    // the hidden button opens the full Preferences dialog, not the notice, so
    // the session reminder must not press it for a visitor who already chose.
    function consentChosen() {
      try {
        return document.cookie.split('; ').some(function (pair) {
          return pair.indexOf('_pandectes_gdpr=') === 0;
        });
      } catch (e) {
        // cookies unreadable (sandboxed frame): treat as not chosen
        return false;
      }
    }

    function sessionSeen() {
      try {
        if (sessionStorage.getItem(SESSION_KEY)) return true;
        sessionStorage.setItem(SESSION_KEY, '1');
      } catch (e) {
        // storage blocked: show the notice on this page and leave it at that
      }
      return false;
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href$="#cookie-preferences"], [data-ps-cookie-preferences]');
      if (!link) return;
      event.preventDefault();
      openConsentNotice();
    });

    // Pandectes inserts its element, attaches the shadow root and renders its
    // button on its own schedule, and none of that fires a mutation here, so
    // poll (every 500ms, for up to 30s).
    var tries = 0;
    var sessionChecked = false;
    (function waitForConsent() {
      var root = consentRoot();
      if (root) {
        styleConsent(root);
        var rendered = root.querySelector('.widget, .dialog');
        if (rendered && !sessionChecked) {
          sessionChecked = true;
          if (!consentChosen() && !sessionSeen()) openConsentNotice();
          return;
        }
      }
      if (++tries < 60) setTimeout(waitForConsent, 500);
    })();
  })();

  // ── Rebuy Smart Cart: "Upgrade to <larger pack>" (A/B variant B, task 3.1) ──
  // The button is rendered by the variant B Cart Items template in Rebuy
  // (rebuy-smartcart-cart-items-variant-b.html): a one-time N-Pack line gets
  // "Upgrade to 6-Pack & Save N%" instead of the subscription switch. Rebuy's
  // Vue templates cannot reach window, so the click is handled here.
  //
  // The swap is two requests: add the larger pack, then remove the old line.
  // Adding first means a failure leaves the cart as it was (nothing removed);
  // if the removal fails, the added line is taken back out.
  // Other carts never render [data-ps-size-upgrade], so this is inert there.
  (function () {
    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Cart request failed');
          return data;
        });
      });
    }

    function refreshCart() {
      if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchCart === 'function') {
        return Promise.resolve(Rebuy.Cart.fetchCart());
      }
      return Promise.resolve();
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ps-size-upgrade]');
      if (!button || button.disabled) return;
      event.preventDefault();

      var lineKey = button.dataset.lineKey;
      var toVariant = parseInt(button.dataset.variantId, 10);
      var quantity = parseInt(button.dataset.quantity, 10) || 1;
      if (!lineKey || !toVariant) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      post('/cart/add.js', { items: [{ id: toVariant, quantity: quantity }] })
        .then(function (added) {
          var line = added.items && added.items[0];
          return post('/cart/change.js', { id: lineKey, quantity: 0 }).catch(function (error) {
            // Keep the cart as it was: take back only what was just added.
            // add.js merges into an existing one-time line of the larger pack,
            // so its quantity may already include packs the shopper had.
            var undo = line
              ? post('/cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity - quantity) }).catch(function () {})
              : Promise.resolve();
            return undo.then(function () { throw error; });
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('ps:size-upgrade', {
            detail: { from: parseInt(button.dataset.fromVariant, 10) || null, to: toVariant, quantity: quantity }
          }));
        })
        .catch(function (error) {
          console.warn('[PS] Size upgrade failed:', error && error.message);
        })
        .then(function () {
          // Rebuy re-renders the line on refresh; re-enable in case it does not.
          return refreshCart();
        })
        .then(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    });
  })();

  // ── Search modal: keep backdrop swipes off the page (iOS Safari) ──
  // A modal <dialog> receives touches on its backdrop too. On iOS a swipe over
  // the dimmed page below the panel scrolls the locked page instead, and Safari
  // keeps the next swipe on that scroller, so the first swipe on the results
  // after it did nothing. Cancelling moves that start outside the panel keeps
  // every swipe on the results list. Taps are untouched, so closing the modal
  // by tapping outside still works.
  (function () {
    var dialog = document.querySelector('dialog.search-modal__content');
    if (!dialog) return;

    var startedOutside = false;

    dialog.addEventListener('touchstart', function (event) {
      var touch = event.touches[0];
      var rect = dialog.getBoundingClientRect();
      startedOutside = touch.clientY < rect.top || touch.clientY > rect.bottom ||
        touch.clientX < rect.left || touch.clientX > rect.right;
    }, { passive: true });

    dialog.addEventListener('touchmove', function (event) {
      if (startedOutside) event.preventDefault();
    }, { passive: false });
  })();

  // ── Yotpo rewards page: working JOIN NOW / SIGN UP / LOG IN buttons ──
  // Yotpo sends LOG IN (hero, "Refer a friend", the guest overlay of a "Ways to
  // earn" tile on mobile) and, with new customer accounts, the hero's JOIN NOW too
  // to /account/login?checkout_url=<absolute page URL>, some of them on the old
  // plantstrongfoods.com domain; the overlay's SIGN UP goes to
  // http://plantstrongfoods.com/account/register. Shopify turns the login link into
  // /customer_authentication/login?return_to=https://..., which answers 400 Bad
  // Request: return_to only accepts relative URLs
  // (https://shopify.dev/docs/storefronts/themes/sign-in). The click is taken over
  // here in the capture phase, before Yotpo's own handler runs, and sent to the
  // documented sign-in path with a relative return_to. New customer accounts have
  // one sign-in page for new and returning customers (email + one-time code), so
  // JOIN NOW and LOG IN lead to the same place. The referral widget hardcodes its
  // URL, so Yotpo's admin cannot fix this.
  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '.yotpo-login-link button, .yotpo-register-link button, ' +
      '.yotpo-sign-up-button button, a.yotpo-sign-in-button'
    );
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = '/customer_authentication/login?return_to=' +
      encodeURIComponent(window.location.pathname + window.location.search);
  }, true);

  // ── External links open in a new tab ──
  // Links to other sites (social networks, the podcast and events sites, partner
  // pages) should not take the shopper away from the store. Most of them do not
  // live in the theme code: they come from menus, section settings, product and
  // blog content edited in the admin, and app widgets rendered later. So instead
  // of patching every template, the decision is made at click time and covers
  // links added after page load too. Opt out with data-same-tab on the link.
  //
  // The store's own hosts stay in the same tab: plantstrong.com and its
  // subdomains, the legacy plantstrongfoods.com still linked from old content,
  // *.myshopify.com, and the Shopify-hosted customer account / Shop sign-in
  // (shopify.com/<id>/account, shop.app), which belong to the shopping flow.
  // Links inside iframes or closed shadow roots are out of reach by design.
  var PS_INTERNAL_HOST = /(^|\.)(plantstrong\.com|plantstrongfoods\.com|myshopify\.com|shopify\.com|shop\.app)$/;

  function psIsExternalLink(link) {
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return false; // mailto:, tel:, javascript:
    var host = link.hostname.toLowerCase();
    return host !== window.location.hostname && !PS_INTERNAL_HOST.test(host);
  }

  // Bubble phase on window: it runs after every widget's own click handler, so
  // a link whose widget called preventDefault() (modals, custom navigation) is
  // left alone. The browser follows the link only after dispatch ends, so the
  // target set here still applies. composedPath() reaches links that render in
  // an open shadow root (the account popover, app widgets).
  window.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    var path = event.composedPath ? event.composedPath() : [event.target];
    var link = null;
    for (var i = 0; i < path.length; i++) {
      if (path[i].tagName === 'A' && path[i].href) { link = path[i]; break; }
    }
    if (!link || link.hasAttribute('download') || link.hasAttribute('data-same-tab')) return;
    // An explicit target is respected, except _self, which page builders and
    // the rich text editor write by default.
    var target = link.getAttribute('target');
    if (target && target !== '_self') return;
    if (!psIsExternalLink(link)) return;

    link.target = '_blank';
    var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') === -1) rel.push('noopener');
    link.setAttribute('rel', rel.join(' '));
  });

});
